module.exports = __webpack_public_path__ + "static/img/download-guide.ff0abff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/download-guide.png
// module id = z04a
// module chunks = 2